import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * The card shell every entity subpage sits in: a fixed-height header row with the page title, a
 * right-aligned slot for that page's actions, and a scrolling body that shows a spinner until
 * {@link isLoaded}.
 *
 * ```html
 * <app-page-form-shell [isLoaded]="isLoaded">
 *   <header header-content>{{ 'Something.Title' | translate }}</header>
 *   <button header-button-content mat-raised-button>Save</button>
 *   <div form-content>...</div>
 * </app-page-form-shell>
 * ```
 *
 * Replaces `organization-base-form` and `location-base-form`, which were the same component copied
 * once and then allowed to drift: the location copy put `[hidden]="!isLoaded"` on `<ng-content>`,
 * which is not a rendered element, so that binding did nothing and location pages painted their
 * form content underneath the spinner while loading. The organization copy had fixed it by hiding
 * the wrapping div instead, and nobody back-ported it. This is the organization copy.
 *
 * Title styling belongs to `.subHeader` in this component's stylesheet - not to the consuming page.
 * Three organization subpages used to re-declare it inside the header slot at three different sizes
 * because the class had no definition to change.
 */
@Component({
  selector: 'app-page-form-shell',
  templateUrl: './page-form-shell.component.html',
  styleUrls: ['./page-form-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageFormShellComponent {
  /** While false the body is hidden and a spinner shows in its place. */
  @Input() isLoaded = false;
}
